import React from 'react';
import { ORDER_PERIOD_OPTIONS } from './dashboardPeriodUtils';

/**
 * Pill filter for dashboard order analytics (Today, 7d, 30d, …).
 */
export function OrderPeriodFilter({
  period,
  onPeriodChange,
  customFrom,
  customTo,
  onCustomFromChange,
  onCustomToChange,
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-2 sm:gap-3">
      <div className="inline-flex flex-wrap rounded-lg border border-slate-200 bg-slate-100/80 p-0.5">
        {ORDER_PERIOD_OPTIONS.map((opt) => (
          <button
            key={opt.id}
            type="button"
            onClick={() => onPeriodChange(opt.id)}
            className={`px-3 py-1.5 text-xs sm:text-sm font-medium rounded-md transition-colors ${
              period === opt.id
                ? 'bg-white text-slate-900 shadow-sm'
                : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
      {period === 'CUSTOM' ? (
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <input
            type="date"
            value={customFrom || ''}
            onChange={(e) => onCustomFromChange(e.target.value)}
            className="rounded-lg border border-slate-200 px-2 py-1.5 text-sm"
          />
          <span className="text-slate-400">–</span>
          <input
            type="date"
            value={customTo || ''}
            onChange={(e) => onCustomToChange(e.target.value)}
            className="rounded-lg border border-slate-200 px-2 py-1.5 text-sm"
          />
        </div>
      ) : null}
    </div>
  );
}

export default OrderPeriodFilter;
